import { publicShopReader, type PublicReview } from "@fusiqo/vozqi-shared";
import { useState } from "react";

export type MoreReviews = {
  reviews: PublicReview[];
  /** More to ask for: «Ver más reseñas». */
  more: boolean;
  failed: boolean;
  loadMore: () => void;
};

/** The Worker's own doors, on this origin. */
const reader = publicShopReader("", (url) => fetch(url));

/**
 * «Ver más reseñas» (decision 17): the profile's reviews after the five it
 * came with, a page at a time from `profile.reviews.next`, added under them.
 * The sibling of `use-more-items.ts`. A failure keeps the cursor, so the
 * button asks again.
 */
export function useMoreReviews(slug: string, next: string | null): MoreReviews {
  const [reviews, setReviews] = useState<PublicReview[]>([]);
  const [cursor, setCursor] = useState(next);
  const [status, setStatus] = useState<"idle" | "loading" | "failed">("idle");

  const loadMore = (): void => {
    if (cursor === null || status === "loading") return;
    setStatus("loading");
    reader.reviews(slug, cursor).then(
      (page) => {
        setReviews((before) => [...before, ...page.items]);
        setCursor(page.nextCursor);
        setStatus("idle");
      },
      () => setStatus("failed"),
    );
  };

  return { reviews, more: cursor !== null && status !== "loading", failed: status === "failed", loadMore };
}
